export default {
  Registro: 1,
  EvaluacionAdicional: 2,
  EvaluacionTrianual: 3,
  PEI: 4,
  Inicial: 5,
  Reactivacion: 6,
};
